export interface ReleaseUserMynumbercardRequest {
  id: string
}

export function ReleaseUserMynumbercardRequestToJSON(
  value: ReleaseUserMynumbercardRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
